{
  "footer": {
    "alreadyPartner": "Já é um parceiro?",
    "back": "Voltar",
    "letsgo": "Começa agora!",
    "login": "Entrar",
    "next": "Seguinte",
    "readMore": "Mais informações",
    "signUp": "Regista-te"
  },
  "formErrors": {
    "address": "O endereço não foi encontrado. Por favor, insere um válido.",
    "businessName": "Este nome não está disponível. Adiciona outro, por favor.",
    "email": "Este email já está registado.",
    "verificationCode": "Código inválido\n"
  },
  "global": {
    "title": "Junta-te à Treatwell"
  },
  "input": {
    "businessName": {
      "invalid": "O nome do espaço é demasiado longo",
      "label": "Nome do Estabelecimento",
      "required": "Obrigatório"
    },
    "businessSegment": {
      "aesthetics": "Estética",
      "barber": "Barbeiro",
      "beautician": "Esteticista",
      "hair-removal": "Depilação",
      "hairdresser": "Cabeleireiro",
      "massage": "Massagem",
      "nails": "Unhas",
      "primary": "Principal",
      "required": "Seleciona pelo menos uma opção",
      "spa": "Spa"
    },
    "businessType": {
      "dedicatedSpaceCheckbox": "Confirmo que tenho atividade aberta junto da Autoridade Tributária e Aduaneira Portuguesa",
      "home": "Serviço ao domicílio <0>- os clientes vêm a tua casa</0>",
      "mobile": "Serviço móvel <0>- deslocas-te aos teus clientes</0>",
      "mobileCheckbox": "Pretendo usar APENAS a agenda de reservas Treatwell, SEM Markeplace para receber reservas online",
      "mobileMessage": "Infelizmente, devido a restrições o nosso marketplace só exibe estabelecimentos com endereço fixo.",
      "required": "Seleciona uma opção\n",
      "shop": "Estabelecimento comercial <0>- os clientes à tua loja</0>\n"
    },
    "city": {
      "invalid": "O nome da cidade é demasiado longo\n",
      "label": "Cidade",
      "required": "Obrigatório\n"
    },
    "country": {
      "label": "País",
      "required": "Obrigatório"
    },
    "email": {
      "invalid": "Inválido",
      "label": "Email",
      "required": "Obrigatório"
    },
    "firstName": {
      "invalid": "Por favor, lembra-te de não usar caracteres especiais\n",
      "label": "Nome",
      "required": "Obrigatório"
    },
    "lastName": {
      "invalid": "Por favor, lembra-te de não usar caracteres especiais\n",
      "label": "Apelido",
      "required": "Obrigatório"
    },
    "marketing": {
      "label": "Quero receber emails com recomendações personalizadas para o crescer do meu negócio"
    },
    "password": {
      "hint": "Mínimo de 8 caracteres",
      "invalid": "A password deve ter no mínimo 8 caracteres",
      "label": "Password",
      "required": "Obrigatório"
    },
    "phoneNumber": {
      "invalid": "Número de telefone inválido",
      "label": "Número de telefone",
      "required": "Obrigatório"
    },
    "postalCode": {
      "invalid": "O código postal é demasiado longo",
      "label": "Código Postal",
      "required": "Obrigatório"
    },
    "privacy": {
      "label": "Ao registares na conta Freemium, aceitas a nossa <0>política de privacidade</0> e os <1>termos e condições</1>"
    },
    "searchBusiness": {
      "label": "Procurar estabelecimento\n"
    },
    "street": {
      "invalid": "O endereço é demasiado longo\n",
      "label": "Endereço",
      "required": "Obrigatório"
    }
  },
  "salesMode": {
    "enterPassword": "Introduz a senha para o modo de vendas",
    "invalidPassword": "Senha incorreta\n"
  },
  "stepContext": {
    "attractNewClients": "Atraia novos clientes",
    "buildRelationships": "Construa relações ainda melhores com seus clientes",
    "growBusiness": "Faça seu negócio crescer de forma bela",
    "manageAppointments": "Gerencie todos os seus compromissos em movimento",
    "prompt": "Estás a apenas 3 minutos de te juntares a mais de 75.000 salões que já simplificam a gestão e aumentam as suas receitas com a Treatwell.<br /><br />Com a Treatwell, vais conseguir:",
    "prompt2": "...e muito mais.",
    "title": "<0>Aderir à Treatwell</0> - a maior plataforma de cabeleireiros e salões de beleza da Europa - nunca foi tão fácil."
  },
  "stepCounter": {
    "step0": "Passo 1",
    "step1": "Passo 1",
    "step2": "Passo 2",
    "step3": "Passo 3",
    "step4": "Passo 4",
    "step5": "Parabéns!"
  },
  "stepEmailVerification": {
    "resend": "Reenviar\n",
    "subTitle1": "Insere o código e completa o registo\n",
    "subTitle2": "Não o recebeste?",
    "title": "<0>Já está quase,</0> enviámos-te um email com um código de 6 dígitos"
  },
  "stepError": {
    "accountCreation": "A criar a tua conta",
    "body": "Estamos a experienciar dificuldades técnicas.\\nAguarda um momento e tenta novamente.",
    "bodyWithError": "Estamos a enfrentar problemas com {{reason}}.\\nPor favor, espera um minuto e tenta novamente.",
    "button": "Tenta novamente",
    "title": "Oops, algo correu mal!"
  },
  "stepFinal": {
    "joke1Punchline": "Para fazerem bons cortes",
    "joke1Setup": "Porque é que os futebolistas vão tanto ao cabeleireiro?",
    "joke2Punchline": "Um shampoodle!",
    "joke2Setup": "Que cão tem uma cabeleireira?",
    "joke3Punchline": "Com ou sem terapia?",
    "joke3Setup": "Qual é o preço de uma manicure?",
    "joke4Punchline": "Um cortado!",
    "joke4Setup": "O que pede o barbeiro no café?",
    "joke5Punchline": "",
    "joke5Setup": "",
    "subTitle": "Enquanto esperas, estas até te vão deixar despenteado!",
    "title": "Obrigada, vamos montar o teu establecimento!<br />Dá-nos <0>dois minutos...</0>"
  },
  "stepFinalRedirectLogin": {
    "alternativeButton": "Inscreve-te",
    "alternativeMessage": "Estás a usar o mesmo local para registar um novo salão?",
    "button": "Regista-te",
    "message": "<0>Boas notícias!</0> O teu establecimento já está configurado na Treatwell"
  },
  "stepFourForm": {
    "prompt1": "Usaremos esta informação para criar a tua conta e contactar-te se necessário",
    "title": "Conta-me sobre ti"
  },
  "stepOneForm": {
    "prompt1": "Procura ou introduz o nome do teu espaço\n",
    "title": "Conta-nos sobre o teu espaço"
  },
  "stepOneSearch": {
    "addManually": "Não o encontras? <0>Adiciona-a manualmente</0>",
    "prompt1": "Escreve o nome do teu espaço",
    "title": "Conta-nos sobre o teu negócio"
  },
  "stepThreeForm": {
    "title": "Que tipo de negócio tens? "
  },
  "stepTwoForm": {
    "prompt1": "Seleciona tudo o que corresponde, escolhendo primeiro o serviço principal",
    "title": "Que serviços ofereces?"
  }
}